import { render, staticRenderFns } from "./pDetails.vue?vue&type=template&id=c3a7b5ae&scoped=true&"
import script from "./pDetails.vue?vue&type=script&lang=js&"
export * from "./pDetails.vue?vue&type=script&lang=js&"
import style0 from "./pDetails.vue?vue&type=style&index=0&id=c3a7b5ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a7b5ae",
  null
  
)

export default component.exports